import { useEffect, useState } from 'react';
import { isRecordEmpty } from 'hx-util';
export var useTrackAudio = function (_a) {
    var audioTrack = _a.audioTrack;
    var _b = useState(false), audioOn = _b[0], setAudioOn = _b[1];
    useEffect(function () {
        if (isRecordEmpty(audioTrack))
            return;
        setAudioOn(audioTrack.isEnabled);
        var handleAudioDisabled = function () {
            setAudioOn(false);
        };
        var handleAudioEnabled = function () {
            setAudioOn(true);
        };
        audioTrack.on('disabled', handleAudioDisabled);
        audioTrack.on('enabled', handleAudioEnabled);
        return function () {
            audioTrack.off('disabled', handleAudioDisabled);
            audioTrack.off('enabled', handleAudioEnabled);
        };
    }, [audioTrack]);
    return { audioOn: audioOn };
};
